import type { LvaMovementListRow } from '@dcc-erp/shared';

// Resolve the human-readable approver for a movement row.
//
// As of the M3/M10 SoD fix, `approvedBy` carries the approving EMPLOYEE's uuid
// (single-namespace identity), and the readable name is persisted to
// `detail.approverLabel`. The audit views must prefer that label so users see a
// name rather than a uuid. Older rows that predate the fix have no
// `approverLabel`, so we fall back to the raw `approvedBy` value.
//
// `detail` is typed as `Record<string, unknown> | null`, so narrow defensively.
export function movementApproverDisplay(m: LvaMovementListRow): string | null {
  const label = m.detail?.approverLabel;
  if (typeof label === 'string' && label.trim() !== '') {
    return label;
  }
  return m.approvedBy ?? null;
}
